/**
 * Asynchronously loads the component for CurlDevPanel
 */

import { lazyLoad } from 'utils/loadable';

export const CurlDevPanel = lazyLoad(
  () => import('./index'),
  module => module.CurlDevPanel,
);
